var fetcher = {};
export {
  fetcher as __exports
};
//# sourceMappingURL=fetcher.js.map
